import { render, staticRenderFns } from "./CtrlTextarea.vue?vue&type=template&id=19227c8a&scoped=true&"
import script from "./CtrlTextarea.vue?vue&type=script&lang=ts&"
export * from "./CtrlTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlTextarea.vue?vue&type=style&index=0&id=19227c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19227c8a",
  null
  
)

export default component.exports